import { Tag } from "app/components/card-list/tag";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useMemo } from "react";

const CardListTagMenu = ({ tags = [], currentTag = "All" }) => {
  const TAG_META = {
    "Food & Beverage": "food",
    "Sports & Fitness": "sports",
    eCommerce: "commerce",
    "Education & Training": "education",
    "Professional Services": "services",
  };
  const { t: trans } = useTranslation();

  const tagList = useMemo(() => {
    return [trans("All"), ...tags].map((tag, index) => (
      <Tag
        key={index}
        text={tag}
        logo={TAG_META[tag]}
        active={currentTag === tag}
      />
    ));
  }, [tags, currentTag]);

  return (
    <div className="mx-auto flex w-[1190px] xl:justify-center">{tagList}</div>
  );
};

export default CardListTagMenu;

CardListTagMenu.propTypes = {
  tags: PropTypes.array,
  currentTag: PropTypes.string,
};
